import { useMemo } from "react";
import { getValForKey } from "../utils/uniqueTv";
import { parseDataKey, resolveDateRange } from "../utils/dateRange";
import { avgVideoConsumptionForDay } from "../utils/avgVideoConsumption";

export function useAvgVideoConsumption({
  rawVideo,
  uniqueTvData,
  sortedVideoKeys,
  startDateInput,
  endDateInput,
}) {
  return useMemo(() => {
    if (!rawVideo || !uniqueTvData || !sortedVideoKeys?.length) return [];

    const u = uniqueTvData?.data ?? uniqueTvData;

    const { start, end } = resolveDateRange({
      sortedKeys: sortedVideoKeys,
      startDateInput,
      endDateInput,
      monthsBack: 3,
    });

    if (!start || !end) return [];

    return sortedVideoKeys
      .map((key) => {
        const day = parseDataKey(key);
        if (!day) return null;

        if (day.isBefore(start, "day") || day.isAfter(end, "day")) return null;

        // Shared with the Management Report so the two never disagree; a day
        // with no unique count comes back null rather than a fabricated zero.
        const avc = avgVideoConsumptionForDay(rawVideo[key], getValForKey(u, key));
        if (avc === null) return null;

        return {
          label: key,
          value: avc,
        };
      })
      .filter(Boolean);
  }, [rawVideo, uniqueTvData, sortedVideoKeys, startDateInput, endDateInput]);
}
